import EventRequestForm from './EventRequestForm.vue';

export default EventRequestForm;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/request/index.ts